module.exports = __webpack_public_path__ + "43a43af5929f1af190b10e3cf6544330.svg";